import format from "date-fns/format";
import moment from "moment";
import { getUserFromCache } from "../user/UserCommon";
import uuid from "uuid/v4";
import { getJsonApi } from "../modules/AmplifyServices";
import { SLOT_TYPES } from "./Constants";
import { cloneDeep, unset } from "lodash";
import { splitUnitFromAddress } from "./addressUnit";

export const convertDollarsToCents = (price) => (price * 100).toFixed(0);

export const convertCentsToDollars = (price) => (price / 100).toFixed(2);

export const formatProductDate = (date) => format(date, "MMM Do, YYYY");

export const getCurrencySymbol = () => {
    const companyCurrency = getUserFromCache()?.company
        ? getUserFromCache().company.currency
        : "$";
    switch (companyCurrency) {
        case "GBP":
            return "£";
        case "CAD":
            return "$";
        case "USD":
            return "$";
        case "AUD":
            return "$";
        case "BBD":
            return "$";
        case "PHP":
            return "₱";
        default:
            return "$";
    }
};

export const getCurrencyNameAndSymbol = () => {
    const companyCurrency = getUserFromCache()?.company
        ? getUserFromCache().company.currency
        : "$";
    switch (companyCurrency) {
        case "GBP":
            return "GBP £";
        case "CAD":
            return "CAD $";
        case "USD":
            return "USD $";
        case "AUD":
            return "AUD $";
        case "BBD":
            return "BBD $";
        case "PHP":
            return "PHP ₱";
        default:
            return "$";
    }
};

export const getCurrencySymbolFromParam = (companyCurrency) => {
    switch (companyCurrency) {
        case "GBP":
            return "£";
        case "CAD":
            return "$";
        case "USD":
            return "$";
        case "AUD":
            return "$";
        case "BBD":
            return "$";
        case "PHP":
            return "₱";
        default:
            return "$";
    }
};

export const countryTypeData = [
    { id: "CA", name: "Canada", currency: "CAD" },
    { id: "US", name: "USA", currency: "USD" },
    { id: "AU", name: "Australia", currency: "AUD" },
    { id: "GB", name: "United Kingdom", currency: "GBP" }
];

export const formatOrderDate = (date) =>
    format(date, "ddd h:mm A, MMM Do, YYYY");

export const _findPromotions = (data, tab) => {
    let rows = data;
    if (data && data.length) {
        if (tab === 0) {
            rows = data.filter((item) => {
                return (
                    _getStartOf().diff(_getStartOf(item.startdate), "days") >=
                        0 &&
                    _getStartOf().diff(_getStartOf(item.enddate), "days") < 0
                );
            });
        } else if (tab === 1) {
            rows = data.filter((item) => {
                return (
                    _getStartOf(item.startdate).diff(_getStartOf(), "days") > 0
                );
            });
        } else {
            rows = data.filter((item) => {
                return (
                    _getStartOf(item.enddate).diff(_getStartOf(), "days") <= 0
                );
            });
        }
    }
    return rows;
};

export const filterBookings = (
    rows,
    clientFilter,
    providerFilter,
    serviceTypeId
) => {
    if (serviceTypeId && serviceTypeId !== 0) {
        rows = rows.filter((item) => item.servicetype.id === serviceTypeId);
    }
    if (clientFilter && clientFilter.length === 2) {
        rows = rows.filter((item) =>
            item.client.user.firstname && item.client.user.lastname
                ? item.client.user.firstname
                      .toLowerCase()
                      .includes(clientFilter[0].toLowerCase()) &&
                  item.client.user.lastname
                      .toLowerCase()
                      .includes(clientFilter[1].toLowerCase())
                : false
        );
    }
    if (clientFilter && clientFilter.length === 1) {
        rows = rows.filter((item) =>
            item.client.user.firstname && item.client.user.lastname
                ? item.client.user.firstname
                      .toLowerCase()
                      .includes(clientFilter[0].toLowerCase()) ||
                  item.client.user.lastname
                      .toLowerCase()
                      .includes(clientFilter[0].toLowerCase()) ||
                  item.client.user.emailaddress
                      .toLowerCase()
                      .includes(clientFilter[0].toLowerCase())
                : false
        );
    }
    if (providerFilter && providerFilter.length === 2) {
        rows = rows.filter((item) =>
            item.provider.firstname && item.provider.lastname
                ? item.provider.firstname
                      .toLowerCase()
                      .includes(providerFilter[0].toLowerCase()) &&
                  item.provider.lastname
                      .toLowerCase()
                      .includes(providerFilter[1].toLowerCase())
                : false
        );
    }
    if (providerFilter && providerFilter.length === 1) {
        rows = rows.filter((item) =>
            item.provider.firstname && item.provider.lastname
                ? item.provider.firstname
                      .toLowerCase()
                      .includes(providerFilter[0].toLowerCase()) ||
                  item.provider.lastname
                      .toLowerCase()
                      .includes(providerFilter[0].toLowerCase()) ||
                  item.provider.emailaddress
                      .toLowerCase()
                      .includes(providerFilter[0].toLowerCase())
                : false
        );
    }
    return rows;
};

export const _findBooking = (
    data,
    tab,
    clientFilter,
    providerFilter,
    serviceTypeId,
    dateRangeChange,
    selectedFromDate,
    selectedToDate
) => {
    let rows = [];
    const now = new Date();
    if (data && data.length) {
        if (dateRangeChange) {
            rows = data.filter((item) => {
                return (
                    new Date(item.startdate).getTime() <
                        selectedToDate.getTime() &&
                    new Date(item.startdate).getTime() >
                        selectedFromDate.getTime()
                );
            });
            rows = filterBookings(
                rows,
                clientFilter,
                providerFilter,
                serviceTypeId
            );
            rows.sort((a, b) => {
                return new Date(a.startdate) - new Date(b.startdate);
            });
        } else if (tab === 0) {
            rows = data.filter((item) => {
                return new Date(item.startdate).getTime() > now.getTime();
            });
            rows = filterBookings(
                rows,
                clientFilter,
                providerFilter,
                serviceTypeId
            );
            rows.sort((a, b) => {
                return new Date(a.startdate) - new Date(b.startdate);
            });
        } else {
            rows = data.filter((item) => {
                return new Date(item.startdate).getTime() <= now.getTime();
            });
            console.log("rows", rows);
            rows = filterBookings(
                rows,
                clientFilter,
                providerFilter,
                serviceTypeId
            );
            rows.sort((a, b) => {
                return new Date(b.startdate) - new Date(a.startdate);
            });
        }
    }
    return rows;
};

export const _formatDate = (
    date,
    format = "MMM DD, YYYY",
    showTime = false
) => {
    let formattedDate = moment(date).format(format);
    return formattedDate;
};

export const _getStartOf = (date = moment()) => moment(date).startOf("day");

export const _userRoles = () => {
    let roles = [
        { label: "COMPANY_ADMIN", value: "COMPANY_ADMIN" },
        { label: "PROVIDER", value: "PROVIDER" },
        { label: "CLIENT", value: "CLIENT" }
    ];
    return roles;
};

export const prepareLocationPath = (
    countryTypeId,
    addressState,
    addressCity,
    postalCode
) => {
    return `${countryTypeId ? countryTypeId.trim().toLowerCase() : ""}/${
        addressState ? addressState.trim().toLowerCase() : ""
    }/${addressCity ? addressCity.trim().toLowerCase() : ""}/${
        postalCode ? postalCode.trim().replace(/\s/g, "").toLowerCase() : ""
    }/${uuid()}`;
};

export const jsonParse = (
    jsonString,
    defaultValue = undefined,
    loggingMessage = "Error parsing json"
) => {
    if (typeof jsonString !== "string") return defaultValue;
    try {
        return JSON.parse(jsonString);
    } catch {
        console.log(loggingMessage);
        return defaultValue;
    }
};
export const escapeQuotes = (value) => {
    if (typeof value !== "string") return value;
    return value.replace(/"/g, '""'); //double the quotes
};
export const tableDateFormat = (date) => moment(date).format("MMM D, Y");
export const twentyFourHourTimeToAmPm = (time) => {
    const [hours, minutes] = time.split(":");
    return `${hours % 12}:${minutes} ${hours > 12 ? "PM" : "AM"}`;
};

export function getCountryCode(country) {
    if (!country) return "CA";
    const countryCodes = {
        Canada: "CA",
        Can: "CA",
        USA: "US",
        "United States": "US",
        "United Kingdom": "GB",
        UK: "GB",
        England: "GB",
        Jamaica: "JM",
        Australia: "AU"
    };

    return countryCodes[country] ? countryCodes[country] : "CA";
}

export function isCountryImperial(country) {
    const imperialCountries = ["GB", "US"];
    return imperialCountries.includes(getCountryCode(country));
}

export function formatToISODateOnly(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

export const isNumeric = (n) => !isNaN(parseFloat(n)) && isFinite(n);
export const getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) return "th"; // Special case for 11th-13th
    switch (day % 10) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};
export const unpackAwsRecords = (record, jsonAttributeNames = []) => {
    if (Array.isArray(record)) {
        return record.map((item) => unpackAwsRecords(item, jsonAttributeNames));
    }

    return {
        ...record,
        ...jsonAttributeNames.reduce((acc, attributeName) => {
            if (record[attributeName]) {
                acc[attributeName] = JSON.parse(record[attributeName]);
            }
            return acc;
        }, {})
    };
};

export async function getPlaceDetails(place_id) {
    const result = await getJsonApi(
        "mapdirection",
        `/placedetails/${place_id}`
    );
    if (result && result.success) {
        return result.placedetails;
    } else {
        return null;
    }
}

export function sanitizeSubdomain(subdomain) {
    return subdomain.toLowerCase().replace(/[^A-Za-z0-9-]/g, "");
}

//Function to format a name, by removing any white space from beginning & end, making it lower case, and replacing itermediate spaces with '-' symbols
export function sanitizeString(name) {
    return name.trim().toLowerCase().replace(/\s+/g, "-");
}

export const truncateName = (first, last, maxLen = 12) => {
    const fullName = `${first} ${last}`;
    if (fullName.length <= maxLen) return fullName;
    if (first.length >= maxLen) return `${first.substring(0, maxLen)}...`;
    return `${first} ${last.substring(0, maxLen - first.length - 1)}...`;
};

export function cleanPhoneNumber(phoneNumber) {
    return phoneNumber.replace(/[^+\d]/g, "");
}

export function getBaseDate(yyyymmdd) {
    const [y, m, d] = yyyymmdd.split("-");
    return new Date(Number(y), Number(m) - 1, Number(d), 0, 0, 0);
}

export const getSlotType = (selectedSlot) => {
    if (selectedSlot?.travelType === "ON-EMPTY-DAY") {
        return SLOT_TYPES.SUGGESTED_SLOT_EMPTY_DAY;
    } else if (
        selectedSlot?.travelTimeMins <= 5 ||
        selectedSlot?.travelType.startsWith("SAME-LOCATION")
    ) {
        return SLOT_TYPES.SUGGESTED_SLOT_OPTIMIZED;
    } else {
        return SLOT_TYPES.SUGGESTED_SLOT;
    }
};

/**
 * Sanitizes an object by removing specified attributes.
 * Safely removes both top-level and nested attributes using dot notation paths.
 * Non-failing - if any attribute path does not exist, it will be silently ignored.
 *
 * @param {Object} object - The object to sanitize
 * @param {string[]} attributesToRemove - Array of attribute paths to remove from the object.
 *   Supports dot notation for nested attributes (e.g., 'user.email', 'profile.address.city').
 *   If a path does not exist in the object, it will be safely ignored.
 *
 * @returns {Object} A clone of the original object with the specified attributes removed.
 *
 * @example
 * const sanitized = sanitizeObject(user, [
 *   'metadata.internalId'
 * ]);
 *
 */
export function sanitizeObject(object, attributesToRemove) {
    if (!object || typeof object !== "object") {
        return object;
    }

    //creates a deep clone of the object to avoid mutating the original
    const sanitizedObject = cloneDeep(object);

    //remove each attribute path
    attributesToRemove.forEach((attributePath) => {
        unset(sanitizedObject, attributePath);
    });

    return sanitizedObject;
}

//helper function to format the date in "MMM D, YYYY" format
export const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
};

//helper function to parse RRULE and format days to a readable string
export const formatDaysFromRRule = (rRule) => {
    if (!rRule) return "";

    const byDayMatch = rRule.match(/BYDAY=([^;]+)/);
    if (!byDayMatch) return "";

    const days = byDayMatch[1].split(",");

    const dayOrder = {
        MO: 0,
        TU: 1,
        WE: 2,
        TH: 3,
        FR: 4,
        SA: 5,
        SU: 6
    };

    const dayMap = {
        MO: "Mo",
        TU: "Tu",
        WE: "We",
        TH: "Th",
        FR: "Fr",
        SA: "Sa",
        SU: "Su"
    };

    const sortedDays = days.sort((a, b) => dayOrder[a] - dayOrder[b]);

    const groups = [];
    let currentGroup = [sortedDays[0]];

    for (let i = 1; i < sortedDays.length; i++) {
        const currentDay = sortedDays[i];
        const lastDay = currentGroup[currentGroup.length - 1];

        //check for consecutive days
        if (dayOrder[currentDay] === dayOrder[lastDay] + 1) {
            currentGroup.push(currentDay);
        } else {
            groups.push(currentGroup);
            currentGroup = [currentDay];
        }
    }
    groups.push(currentGroup);

    //formate the groups
    const formattedDays = groups.map((group) => {
        if (group.length === 1) {
            return dayMap[group[0]];
        } else {
            return `${dayMap[group[0]]}–${dayMap[group[group.length - 1]]}`;
        }
    });

    return formattedDays.join(", ");
};

//helper function to extract city from addressOneLine
export const extractCity = (addressOneLine) => {
    if (!addressOneLine) return "Unknown City";

    // drop a unit segment ("..., Unit 100, Ottawa, ...") so the segment
    // after the street is always the city
    const { baseAddress } = splitUnitFromAddress(addressOneLine);
    const parts = baseAddress.split(",");
    if (parts.length >= 2) {
        return parts[1].trim();
    }

    return "Unknown City";
};
